import React from 'react';
import { PolicyData, withPolicyContext } from '../../context/policy';
import { BodyContainer, LayoutContainer, TopContainer } from '../common';
import LargeCenterSpinner from '../LargeCenterSpinner';
import AcceptedQuoteActions from '../policy/Actions/AcceptedQuoteActions';
import DeclinedQuoteActions from '../policy/Actions/DeclinedQuoteActions';
import DraftPolicyQuoteActions from '../policy/Actions/DraftPolicyQuoteActions';
import PolicyActions from '../policy/Actions/PolicyActions';
import QuotedQuoteActions from '../policy/Actions/QuotedQuoteActions';
import Breadcrumbs from '../policy/Breadcrumbs';
import PolicyOverview from '../policy/PolicyOverview';

interface Props {
	children?: JSX.Element | JSX.Element[];
	policyData: PolicyData;
	loading: boolean;
}

const QuoteContentLayout = (props: Props) => {
	const { selectedQuote, policy } = props.policyData;
	const isDraft = selectedQuote?.state === 'draft';
	const isQuoted = selectedQuote?.state === 'quoted';
	const isAccepted = selectedQuote?.state === 'accepted';
	const isDeclined = selectedQuote?.state === 'declined';
	const isIssued = policy.issuedTimestamp;

	const renderActions = () => {
		if (isIssued) {
			return <PolicyActions />;
		}
		if (isDraft) {
			return <DraftPolicyQuoteActions />;
		}
		if (isQuoted) {
			return <QuotedQuoteActions />;
		}
		if (isAccepted) {
			return <AcceptedQuoteActions />;
		}
		if (isDeclined) {
			return <DeclinedQuoteActions />;
		}
		return null;
	};

	return (
		<>
			{props.loading ? <LargeCenterSpinner /> : null}
			<TopContainer>
				<Breadcrumbs />
				{renderActions()}
			</TopContainer>
			<LayoutContainer>
				<BodyContainer>
					<PolicyOverview />
					{props.children}
				</BodyContainer>
			</LayoutContainer>
		</>
	);
};

export default withPolicyContext<Props>(QuoteContentLayout);
